import { chatsApiHostName } from "../endpoint";
import { defaultHeaders } from "../headers";

export const getContacts = async () => {
  try {
    const response = await fetch(`${chatsApiHostName}/users`, {
      method: "GET",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });

    // Handle session expiration
    if (response.status === 401 || response.status === 403) {
      console.warn("Session expired, redirecting to login");
      localStorage.removeItem("access_token");
      localStorage.removeItem("expiresIn");
      localStorage.removeItem("currentUser");
      window.location.href = "/login";
      return [];
    }

    if (response.status !== 200) {
      throw new Error("Error fetching contacts");
    }
    const { data } = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching contacts:", err.message);
    return []; // Return empty array instead of object
  }
};
